var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLucidePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9961 2.99966C17.2508 2.69869 17.5658 2.45372 17.9211 2.28034C18.2764 2.10697 18.6642 2.009 19.0597 1.99267C19.4553 1.97635 19.8499 2.04204 20.2185 2.18555C20.587 2.32905 20.9215 2.54723 21.2004 2.82618C21.4793 3.10513 21.6967 3.43872 21.8386 3.8057C21.9806 4.17268 22.0439 4.56499 22.0247 4.95764C22.0055 5.35028 21.9041 5.73465 21.727 6.08623C21.5499 6.43781 21.301 6.74889 20.9961 6.99966L7.49609 20.4997L1.99609 21.9997L3.49609 16.4997L16.9961 2.99966Z",
    stroke: "#797A7E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucidePen);
export default __webpack_public_path__ + "static/media/lucide_pen.55f2eb3e329d43afe3fb55405f4b1806.svg";
export { ForwardRef as ReactComponent };